<agr-wrapper-site-sidenav [collapsed]="true">
  <router-outlet></router-outlet>
</agr-wrapper-site-sidenav>
<app-field-plan-customer-selection-custom-config></app-field-plan-customer-selection-custom-config>
